import { render } from "./BuyBox.vue?vue&type=template&id=a0e4274c&scoped=true"
import script from "./BuyBox.vue?vue&type=script&lang=js"
export * from "./BuyBox.vue?vue&type=script&lang=js"

import "./BuyBox.vue?vue&type=style&index=0&id=a0e4274c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e4274c"]])

export default __exports__